import React, { useMemo, useState } from 'react'
import { CONTROL_STATUS } from '@trustero/trustero-api-web/lib/model/control_pb'
import { BasicDropdown } from 'src/components/Reusable/BasicDropdown/BasicDropdown'
import {
  BASIC_DROPDOWN_ALIGN,
  BASIC_DROPDOWN_DROP,
} from 'src/components/Reusable/BasicDropdown/BasicDropdown.constants'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import { useBasicDropdown } from 'src/components/Reusable/BasicDropdown/context/BasicDropdownContext'
import { BasicDropdownItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.types'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import isFunction from 'lodash/isFunction'
import {
  ControlStatusDropdownOptions,
  ControlStatusOptions,
} from './Dropdowns.constants'

export const ControlStatusDropdown = ({
  control,
  initialStatus,
  onSelect,
  isDisabled,
}: {
  control: Control.AsObject
  initialStatus: CONTROL_STATUS
  onSelect?: (status: CONTROL_STATUS) => void
  isDisabled?: boolean
}): JSX.Element => {
  const { openDropdownId, setOpenDropdownId } = useBasicDropdown()
  const dropdownId = `control-status-${control.modelId}`
  const isOpen = openDropdownId === dropdownId
  const canUpdateStatus = useCanPerformAction<Control.AsObject>(
    CAPABILITY.CAN_UPDATE_CONTROL_STATUS,
    control,
  )

  const [selectedItem, setSelectedItem] = useState<BasicDropdownItem>({
    name: ControlStatusOptions[initialStatus as CONTROL_STATUS],
    value: initialStatus,
  })
  const isDropdownisabled = !canUpdateStatus || isDisabled
  const items = useMemo(
    () =>
      ControlStatusDropdownOptions.filter(
        (option) => option.key !== CONTROL_STATUS.NOTAPPLICABLE,
      ).map(
        (option) =>
          ({
            name: option.label,
            value: option.key,
          } as BasicDropdownItem),
      ),
    [],
  )

  const updateStatus = async (item: BasicDropdownItem) => {
    setSelectedItem(item)
    if (isFunction(onSelect)) {
      onSelect(item.value as CONTROL_STATUS)
    }
  }

  const handleToggle = (isOpen: boolean) => {
    if (isOpen) {
      setOpenDropdownId(dropdownId)
    } else {
      setOpenDropdownId(null)
    }
  }

  return (
    <BasicDropdown
      selectedItem={selectedItem}
      items={items}
      onSelect={updateStatus}
      drop={BASIC_DROPDOWN_DROP.DOWN}
      align={BASIC_DROPDOWN_ALIGN.END}
      backgroundColor={
        ControlStatusDropdownOptions.find(
          (option) => option.key === selectedItem.value,
        )?.colors.background
      }
      borderColor={
        ControlStatusDropdownOptions.find(
          (option) => option.key === selectedItem.value,
        )?.colors.border
      }
      onToggle={handleToggle}
      show={isOpen}
      offset={4}
      disabled={
        isDropdownisabled || selectedItem.value === CONTROL_STATUS.NOTAPPLICABLE
      }
    />
  )
}
